import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=222b41b1&scoped=true&"
import script from "./StatusCell.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StatusCell.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StatusCell.vue?vue&type=style&index=0&id=222b41b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b41b1",
  null
  
)

export default component.exports